import { ConfigApi, Config } from 'api';
import { makeApi } from 'core/api';
import applicationConfig from 'core/config/local';

export async function getConfigEffect(): Promise<Config> {
  const api: ConfigApi = makeApi(ConfigApi);

  return await api.configRetrieve({ distributionPlatformName: applicationConfig.platform });
}
